/* nickname-core.js — генерация ников и ПРОВЕРКА, где они реально пройдут.
 *
 * ЗАЧЕМ ОТДЕЛЬНЫЙ ФАЙЛ
 * --------------------
 * Главная ценность тула — не «сделать красиво», а сказать заранее, что
 * красивое НЕ ПРИМУТ. Это правила, а правила надо проверять тестами, а не
 * глазами. Поэтому здесь только логика: генерация, украшение и валидация под
 * площадки. UI живёт отдельно.
 *
 * ПОЧЕМУ ЭТО ВАЖНО
 * ----------------
 * Сайты-конкуренты (nickgen, symbl.cc, symbolsfornicknames, kakras) выдают
 * ник с ࿇ и ༒ и на этом заканчивают. Человек несёт его в Steam или Telegram и
 * получает отказ, потому что там либо только ASCII, либо запрет на
 * комбинируемые знаки, либо лимит длины. Мы говорим об этом ДО того, как он
 * потратит попытку — этого нет ни у кого.
 *
 * Правила ниже — публичные ограничения площадок; где правило шире реального,
 * оно помечено как приблизительное в тексте страницы, а не выдаётся за точное.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof root !== 'undefined') root.NicknameCore = api;
}(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  // ── Площадки ────────────────────────────────────────────────────────────────

  /**
   * min/max      — длина в кодовых точках (НЕ в UTF-16: эмодзи считается за 1);
   * allow        — регулярка допустимых символов;
   * noCombining  — запрет комбинируемых знаков (ими делают «глючный» текст);
   * note         — ключ пояснения.
   */
  var PLATFORMS = [
    { key: 'steam', min: 1, max: 32, allow: null, noCombining: false },
    { key: 'discord', min: 2, max: 32, allow: /^[a-z0-9._]+$/, noCombining: true },
    { key: 'telegram', min: 5, max: 32, allow: /^[A-Za-z][A-Za-z0-9_]*$/, noCombining: true },
    { key: 'instagram', min: 1, max: 30, allow: /^[A-Za-z0-9._]+$/, noCombining: true },
    { key: 'x', min: 4, max: 15, allow: /^[A-Za-z0-9_]+$/, noCombining: true },
    { key: 'minecraft', min: 3, max: 16, allow: /^[A-Za-z0-9_]+$/, noCombining: true },
    { key: 'roblox', min: 3, max: 20, allow: /^[A-Za-z0-9_]+$/, noCombining: true },
    { key: 'github', min: 1, max: 39, allow: /^[A-Za-z0-9](?:[A-Za-z0-9]|-(?=[A-Za-z0-9])){0,38}$/, noCombining: true }
  ];

  /** Длина В КОДОВЫХ ТОЧКАХ. `'👍'.length` равно 2 — на этом ломаются счётчики. */
  function codePointLength(s) {
    return Array.from(String(s)).length;
  }

  function hasCombining(s) {
    return /[̀-ͯ҃-҉᪰-᫿᷀-᷿⃐-⃰︠-︯]/.test(s);
  }

  /**
   * Проверка ника под площадку.
   * @returns {{key, ok, reasons: string[], length: number}}
   */
  function checkPlatform(nick, platform) {
    var reasons = [];
    var len = codePointLength(nick);
    if (len === 0) reasons.push('empty');
    if (len < platform.min) reasons.push('too_short');
    if (len > platform.max) reasons.push('too_long');
    if (platform.noCombining && hasCombining(nick)) reasons.push('combining');
    if (platform.allow) {
      var test = platform.key === 'discord' ? String(nick).toLowerCase() : String(nick);
      if (!platform.allow.test(test)) reasons.push('charset');
    }
    return { key: platform.key, ok: reasons.length === 0, reasons: reasons, length: len, max: platform.max };
  }

  function checkAll(nick) {
    return PLATFORMS.map(function (p) { return checkPlatform(nick, p); });
  }

  // ── Украшение ───────────────────────────────────────────────────────────────

  // Юникод-алфавиты. ⚠️ Это НЕ шрифты, а отдельные символы: они выглядят как
  // стилизованные буквы, но во многих полях ввода запрещены — ровно поэтому
  // рядом всегда стоит проверка площадок.
  var ALPHABETS = {
    bold: { A: 0x1D400, a: 0x1D41A, zero: 0x1D7CE },
    italic: { A: 0x1D434, a: 0x1D44E, zero: null },
    script: { A: 0x1D49C, a: 0x1D4B6, zero: null },
    fraktur: { A: 0x1D504, a: 0x1D51E, zero: null },
    double: { A: 0x1D538, a: 0x1D552, zero: 0x1D7D8 },
    mono: { A: 0x1D670, a: 0x1D68A, zero: 0x1D7F6 },
    sans: { A: 0x1D5A0, a: 0x1D5BA, zero: 0x1D7E2 }
  };

  // Пропуски в блоке математических букв: часть кодовых точек занята буквами
  // из Letterlike Symbols. Без этой таблицы «script» выдаёт пустые квадратики.
  var HOLES = {
    script: { B: 0x212C, E: 0x2130, F: 0x2131, H: 0x210B, I: 0x2110, L: 0x2112, M: 0x2133, R: 0x211B, e: 0x212F, g: 0x210A, o: 0x2134 },
    fraktur: { C: 0x212D, H: 0x210C, I: 0x2111, R: 0x211C, Z: 0x2128 },
    italic: { h: 0x210E },
    double: { C: 0x2102, H: 0x210D, N: 0x2115, P: 0x2119, Q: 0x211A, R: 0x211D, Z: 0x2124 }
  };

  function stylize(text, style) {
    var map = ALPHABETS[style];
    if (!map) return text;
    var holes = HOLES[style] || {};
    return Array.from(String(text)).map(function (ch) {
      if (holes[ch]) return String.fromCodePoint(holes[ch]);
      if (ch >= 'A' && ch <= 'Z') return String.fromCodePoint(map.A + (ch.charCodeAt(0) - 65));
      if (ch >= 'a' && ch <= 'z') return String.fromCodePoint(map.a + (ch.charCodeAt(0) - 97));
      if (ch >= '0' && ch <= '9' && map.zero) return String.fromCodePoint(map.zero + (ch.charCodeAt(0) - 48));
      return ch;
    }).join('');
  }

  var DECOR = [
    ['꧁', '꧂'], ['༺', '༻'], ['⋆｡°', '°｡⋆'], ['【', '】'], ['♡', '♡'],
    ['✧', '✧'], ['彡', '彡'], ['[', ']'], ['—', '—'], ['⟬', '⟭']
  ];

  function decorate(text, index) {
    var d = DECOR[((index | 0) % DECOR.length + DECOR.length) % DECOR.length];
    return d[0] + text + d[1];
  }

  // ── Генерация ───────────────────────────────────────────────────────────────

  var PARTS = {
    // Части нейтральные и переводимые: словари приходят снаружи, чтобы ник
    // на арабском не собирался из английских корней.
    joiners: ['', '', '_', '.', 'x', '-']
  };

  /** Детерминированный генератор — иначе «ещё вариант» невоспроизводим в тестах. */
  function rng(seed) {
    var s = seed >>> 0 || 1;
    return function () { s ^= s << 13; s ^= s >>> 17; s ^= s << 5; s >>>= 0; return s / 4294967296; };
  }

  /**
   * Собрать ники из словарей.
   * @param {{adjectives:string[], nouns:string[]}} words
   * @param {{count?:number, seed?:number, base?:string, digits?:boolean, maxLen?:number}} opts
   */
  function generate(words, opts) {
    opts = opts || {};
    var rand = rng(opts.seed || 1);
    var count = opts.count || 12;
    var maxLen = opts.maxLen || 16;
    var out = [], seen = {};
    var adj = (words && words.adjectives) || [], nouns = (words && words.nouns) || [];
    var base = (opts.base || '').trim();

    var guard = 0;
    while (out.length < count && guard++ < count * 40) {
      var name;
      if (base) {
        // С основой: пользовательское слово + один модификатор.
        var tail = rand() < 0.5 && nouns.length ? nouns[Math.floor(rand() * nouns.length)] : '';
        var head = !tail && adj.length ? adj[Math.floor(rand() * adj.length)] : '';
        var j = PARTS.joiners[Math.floor(rand() * PARTS.joiners.length)];
        name = head ? head + j + base : base + j + tail;
      } else {
        if (!adj.length || !nouns.length) break;
        name = adj[Math.floor(rand() * adj.length)] + PARTS.joiners[Math.floor(rand() * PARTS.joiners.length)] +
          nouns[Math.floor(rand() * nouns.length)];
      }
      if (opts.digits && rand() < 0.45) name += String(Math.floor(rand() * 90) + 10);
      // ⚠️ Режем по КОДОВЫМ ТОЧКАМ и только по границе, иначе можно разрубить
      // суррогатную пару и получить «квадратик» в конце ника.
      var cps = Array.from(name);
      if (cps.length > maxLen) name = cps.slice(0, maxLen).join('');
      var key = name.toLowerCase();
      if (!name || seen[key]) continue;
      seen[key] = 1;
      out.push(name);
    }
    return out;
  }

  return {
    PLATFORMS: PLATFORMS,
    DECOR: DECOR,
    STYLES: Object.keys(ALPHABETS),
    codePointLength: codePointLength,
    hasCombining: hasCombining,
    checkPlatform: checkPlatform,
    checkAll: checkAll,
    stylize: stylize,
    decorate: decorate,
    generate: generate
  };
}));
